import React, { useContext, useEffect, useState } from "react";
import { DContext } from "../../../context/Datacontext";
import { useNavigate } from "react-router-dom";

export const BasicInformation = () => {

    const { BeURL, instructor, setInstructor , showAlert} = useContext(DContext);
    const navigate = useNavigate()

    const [form, setForm] = useState({
        gender: "",
        dob: "",
        teachingLanguage: "",
        experienceYears: "",
        website: ""
    });

    const [loading, setLoading] = useState(false);

    // ================= AUTO FILL =================
    useEffect(() => {
        if (instructor) {
            setForm({
                gender: instructor.gender || "",
                dob: instructor.dob
                    ? new Date(instructor.dob).toISOString().split("T")[0]
                    : "",
                teachingLanguage: instructor.teachingLanguage || "",
                experienceYears: instructor.experienceYears || "",
                website: instructor.website || ""
            });
        }
    }, [instructor]);

    // ================= HANDLE CHANGE =================
    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    // ================= SUBMIT =================
    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            setLoading(true);

            const res = await fetch(`${BeURL}/update/instructor/profile/basic`, {
                method: "PUT",
                credentials: "include",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(form)
            });

            const data = await res.json();

            if (!res.ok) {
                showAlert(data.message);
                return;
            }

            if (data.success) {
                showAlert(data.message);
                navigate('/instructor/my/experience')
                setInstructor(data.updatedInstructor);
            } else {
                showAlert(data.message);
            }

        } catch (err) {
            console.error("Error in basic information", err);
            showAlert("Something went wrong");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="max-w-5xl bg-white p-6 rounded-xl shadow-sm">

            <h2 className="text-xl font-semibold mb-6">
                Basic Information
            </h2>

            <form onSubmit={handleSubmit} className="space-y-6">

                <div className="grid sm:grid-cols-2 gap-4">

                    {/* Gender */}
                    <div>
                        <label className="text-sm font-medium">Gender</label>
                        <select
                            name="gender"
                            value={form.gender}
                            onChange={handleChange}
                            className="w-full border px-3 py-2 rounded-lg mt-1"
                        >
                            <option value="">Select Gender</option>
                            <option value="male">Male</option>
                            <option value="female">Female</option>
                            <option value="other">Other</option>
                        </select>
                    </div>

                    {/* DOB */}
                    <div>
                        <label className="text-sm font-medium">Date of Birth</label>
                        <input
                            type="date"
                            name="dob"
                            value={form.dob}
                            onChange={handleChange}
                            className="w-full border px-3 py-2 rounded-lg mt-1"
                        />
                    </div>

                    {/* Teaching Language */}
                    <div>
                        <label className="text-sm font-medium">Teaching Language</label>
                        <select
                            name="teachingLanguage"
                            value={form.teachingLanguage}
                            onChange={handleChange}
                            className="w-full border px-3 py-2 rounded-lg mt-1"
                        >
                            <option value="">Select Language</option>
                            <option value="Tamil">Tamil</option>
                            <option value="English">English</option>
                            <option value="Hindi">Hindi</option>
                        </select>
                    </div>

                    {/* Experience */}
                    <div>
                        <label className="text-sm font-medium">Experience (Years)</label>
                        <input
                            type="number"
                            name="experienceYears"
                            placeholder="eg: 3"
                            value={form.experienceYears}
                            onChange={handleChange}
                            className="w-full border px-3 py-2 rounded-lg mt-1"
                        />
                    </div>

                    {/* Website */}
                    <div className="sm:col-span-2">
                        <label className="text-sm font-medium">Website</label>
                        <input
                            name="website"
                            placeholder="https://yourwebsite.com"
                            value={form.website}
                            onChange={handleChange}
                            className="w-full border px-3 py-2 rounded-lg mt-1"
                        />
                    </div>

                </div>

                {/* SAVE BUTTON */}
                <div className="flex justify-end">
                    <button
                        type="submit"
                        disabled={loading}
                        className="bg-primary-600 hover:bg-primary-700 text-white px-6 py-2 rounded-lg"
                    >
                        {loading ? "Saving..." : "Save"}
                    </button>
                </div>


            </form>
        </div>
    );
};
